import PhotoSwipeLightbox from "./photoswipe-lightbox.esm.min.js";

if (document.querySelector("blog-gallery")) {
  await customElements.whenDefined("blog-gallery");
}

const article = document.querySelector(".main-article");

if (article) {
  const images = article.querySelectorAll(
    ".main-article__pic img, .main-article__body img",
  );

  const imageUrlPattern = /\.(avif|gif|jpe?g|png|webp)(?:$|[?#])/i;

  const getFullSizeSource = (image) => {
    const source = image.dataset.src || image.currentSrc || image.src;
    if (!source) return "";

    try {
      const url = new URL(source, window.location.href);
      url.searchParams.delete("width");
      return url.href;
    } catch {
      return source;
    }
  };

  const syncLightboxDimensions = (image, link) => {
    const imageWidth =
      image.naturalWidth ||
      Number.parseInt(image.getAttribute("width"), 10) ||
      image.width ||
      1200;
    const imageHeight =
      image.naturalHeight ||
      Number.parseInt(image.getAttribute("height"), 10) ||
      image.height ||
      imageWidth;

    link.dataset.pswpWidth = imageWidth;
    link.dataset.pswpHeight = imageHeight;
  };

  const prepareImage = (image) => {
    if (image.dataset.articleLightboxPrepared === "true") return;

    const existingLink = image.closest("a");
    const existingHref = existingLink?.href || "";

    if (existingLink && !imageUrlPattern.test(existingHref)) return;

    const source = existingHref || getFullSizeSource(image);
    if (!source) return;

    const link = existingLink || document.createElement("a");

    if (!existingLink) {
      image.before(link);
      link.appendChild(image);
    }

    link.href = source;
    link.dataset.articleLightbox = "";
    link.setAttribute("aria-label", image.alt || "Open image");

    syncLightboxDimensions(image, link);

    if (!image.complete || image.naturalWidth === 0 || image.naturalHeight === 0) {
      image.addEventListener("load", () => {
        syncLightboxDimensions(image, link);
      }, { once: true });
    }

    image.dataset.articleLightboxPrepared = "true";
    image.classList.add("main-article__lightbox-image");
  };

  images.forEach(prepareImage);
  article.classList.add("article-photoswipe");

  const lightbox = new PhotoSwipeLightbox({
    gallery: ".article-photoswipe",
    children: "a[data-article-lightbox]",
    pswpModule: () => import("./photoswipe.esm.min.js"),
    bgOpacity: 1,
    initialZoomLevel: ({ elementSize, panAreaSize }) =>
      Math.min(
        panAreaSize.x / elementSize.x,
        panAreaSize.y / elementSize.y,
      ),
  });

  lightbox.init();
}